import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { hasCustomerErrors } from '../../slices';

export const inject = connect(
    createStructuredSelector({
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        hasError: hasCustomerErrors,
    })
);
